import React, { Component } from 'react';

import logo from '../../../assets/img/nave-black-new-logo.svg';
import illustration from '../../../assets/img/illustrations/maintenance.png'

// Import Style
import '../style.scss';

class Downtime extends Component {
  render() {
    return (
      <div className='downtime maintenance'>
        <div className='top_header downtime_header'>
          <a href='/'><img alt="logo" src={logo} /></a>
        </div>

        <div className='downtime_wrap'>
          <div className='downtime_content'>
            <p>
              We're working on improving our site. <br/>Please check back in a minute.
            </p>
          </div>
          
          <div className='downtime_icon'>
            <img alt="downtime icon" src={illustration}/>
          </div>
        </div>
      </div>
    );
  }
}
export default Downtime;
